export default __webpack_public_path__ + "static/media/aes-dark.996fda49.svg";